var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSinKilometraje(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4 15.447c-3.36 0-6.533 1.306-8.797 3.57L18.2 33.577a7.851 7.851 0 01-5.6 2.31c-4.363 0-7.933-3.524-7.933-7.887 0-4.363 3.57-7.887 7.933-7.887 2.123 0 4.107.817 5.693 2.404l2.637 2.333 3.57-3.127-2.987-2.59a12.532 12.532 0 00-8.913-3.686C5.647 15.447 0 21.093 0 28c0 6.907 5.647 12.553 12.6 12.553 3.36 0 6.533-1.306 8.797-3.57L37.8 22.423a7.851 7.851 0 015.6-2.31c4.363 0 7.933 3.524 7.933 7.887 0 4.363-3.57 7.887-7.933 7.887-2.1 0-4.107-.817-5.693-2.404L35 31.127l-3.5 3.126 2.987 2.614A12.567 12.567 0 0043.4 40.53C50.353 40.53 56 34.907 56 28c0-7-5.647-12.553-12.6-12.553z",
    fill: "#54DCF2"
  })));
}
export default SvgIconSinKilometraje;